/** @module Enums */ /** typedoc */

export enum CreditKindEnum {
    UserBalance = 'UserBalance',
    PreviousSubscriptionProratedRefund = 'PreviousSubscriptionProratedRefund',
}
